import { KEY, TYPE } from './src/constants'

export default [
  { key: KEY.ALLOWED_CARD_TYPES, type: TYPE.ARRAY, required: true },
  { key: KEY.AMOUNT, type: TYPE.STRING, required: true },
  { key: KEY.CHECKOUT_ID, type: TYPE.STRING, required: true },
  { key: KEY.CALLBACK_URL, type: TYPE.URL },
  { key: KEY.CART_ID, type: TYPE.STRING, required: true },
  { key: KEY.CRYPTO_OPTIONS, type: TYPE.ARRAY },
  { key: KEY.CURRENCY, type: TYPE.STRING, required: true },
  { key: KEY.CVC2_SUPPORT, type: TYPE.BOOLEAN },
  { key: KEY.DISPLAY_LANGUAGE, type: TYPE.STRING },
  { key: KEY.SHIPPING_LOCATION_PROFILE, type: TYPE.STRING },
  { key: KEY.SUPPRESS_3DS, type: TYPE.BOOLEAN },
  { key: KEY.SUPPRESS_SHIPPING_ADDRESS, type: TYPE.BOOLEAN },
  { key: KEY.UNPREDICTABLE_NUMBER, type: TYPE.STRING },
  { key: KEY.USER_ID, type: TYPE.STRING },
  { key: KEY.VALIDITY_PERIOD_MINUTES, type: TYPE.NUMBER }
]
